import React from 'react';
import { Badge, Card, CardBody } from 'reactstrap';

const StepCard = ({ number, label, icon, color }) => {
  return (
    <Card className="mb-3 shadow-sm">
      <CardBody className="d-flex align-items-center gap-3">
        <Badge color="light" className="border rounded-circle p-2 text-dark">
          {number}
        </Badge>
        <div className="d-flex align-items-center gap-2">
          <img src={icon} />
          <p className="m-0 fs-14">{label}</p>
        </div>
      </CardBody>
    </Card>
  );
};

export default StepCard;
